/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const AEMScreensIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'AEMScreens',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 36 36"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M12 2H2a2 2 0 0 0-2 2v18a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2Zm0 20H2V4h10ZM23.798 9.34a3.34 3.34 0 1 1 3.34 3.34 3.34 3.34 0 0 1-3.34-3.34ZM32 18.702v6.088a.922.922 0 0 1-.91.934h-.908l-.91 9.342a.922.922 0 0 1-.908.934h-2.728a.922.922 0 0 1-.909-.934l-.909-9.342h-.909A.922.922 0 0 1 22 24.79v-6.088a4.901 4.901 0 0 1 4.833-4.967h.334A4.901 4.901 0 0 1 32 18.702ZM36 3v12a1 1 0 0 1-1 1h-1.239a7.488 7.488 0 0 0-1.44-2H34V4H18v10h3.66a7.455 7.455 0 0 0-1.415 2H17a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1Z"
    />
  </svg>`;
};
